module.exports = __webpack_public_path__ + "img/app_logo.bba5087e.png";